import React from 'react';
import { Empty, Button, theme } from 'antd';
import { Link } from 'react-router-dom';

/**
 * Empty state que ENSEÑA: en vez de "no hay datos", explica de dónde viene la
 * entidad del ciclo y ofrece un CTA directo al paso anterior. Parte de la capa
 * de auto-evidencia (Fase 2).
 *
 * @param {React.ReactNode} title  qué falta / qué es esto
 * @param {React.ReactNode} description  de dónde nace la entidad
 * @param {string} [ctaLabel]  texto del botón
 * @param {string} [ctaTo]  ruta destino del CTA (react-router Link)
 */
function CicloEmpty({ title, description, ctaLabel, ctaTo }) {
  const { token } = theme.useToken();
  return (
    <div style={{ padding: token.paddingXL, textAlign: 'center' }}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div style={{ maxWidth: 440, margin: '0 auto' }}>
            <div style={{ fontWeight: 600, color: token.colorText, marginBottom: 4 }}>{title}</div>
            <div style={{ color: token.colorTextSecondary, fontSize: 13, lineHeight: 1.5 }}>
              {description}
            </div>
          </div>
        }
      >
        {ctaTo ? (
          <Link to={ctaTo}>
            <Button type="primary">{ctaLabel}</Button>
          </Link>
        ) : null}
      </Empty>
    </div>
  );
}

export default CicloEmpty;
